import { render, staticRenderFns } from "./ActivtionForgotPassword.vue?vue&type=template&id=5574eca2&"
import script from "./ActivtionForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ActivtionForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./ActivtionForgotPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports